export const LOGO_URL = `${process.env.BASE_URL}/commerce-ui-logo.svg`
export const ORGANIZATION_NAME = 'Commerce-UI'
export const ORGANIZATION_URL =
  process.env.BASE_URL ?? 'https://commerce-ui.com'
